/// <amd-module name="SuiteCommerce.SizeChart.Chart.Page.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.SizeChart.Chart.Page.View", ["require", "exports", "Backbone", "Backbone.CollectionView", "SuiteCommerce.SizeChart.Chart.View", "suitecommerce_sizechart_page.tpl"], function (require, exports, Backbone_1, BackboneCollectionView, Chart_View_1, sizeChartPageTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ChartPageView = /** @class */ (function (_super) {
        __extends(ChartPageView, _super);
        function ChartPageView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = sizeChartPageTemplate;
            _this.title = _this.model.getPageTitle();
            return _this;
        }
        Object.defineProperty(ChartPageView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'SizeCharts.View': function () {
                        return new BackboneCollectionView({
                            collection: _this.model.charts,
                            childView: Chart_View_1.ChartView,
                            childViewOptions: {
                                showSizeChartTitle: !_this.model.sizeChartSearchKey,
                            },
                        });
                    },
                };
            },
            enumerable: true,
            configurable: true
        });
        ChartPageView.prototype.getContext = function () {
            return {
                isRenderedInModal: this.model.isRenderedInModal,
                pageTitle: this.model.getPageTitle(),
                sizeChartId: this.model.getSizeChartId(),
            };
        };
        return ChartPageView;
    }(Backbone_1.View));
    exports.ChartPageView = ChartPageView;
});
